var map = {
	"./IMG-20240731-WA0158.jpg": 3683,
	"./IMG-20240731-WA0204.jpg": 2651,
	"./IMG-20240731-WA0248.jpg": 3371,
	"./IMG-20240731-WA0252.jpg": 3558,
	"./IMG-20240731-WA0256.jpg": 5746,
	"./IMG-20240825-WA0003.jpg": 3390,
	"./featured1.jpg": 3067,
	"./featured3.jpg": 6362,
	"./g16.jpg": 2321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7085;